import { EndpointSetting } from "@/constants/app/type";
import { FlightState } from "../type";

export const callbackGetGoodFlights: EndpointSetting["caller"] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.get_good_flights.loading = false;
  state.get_good_flights.error = null;
  state.get_good_flights.success = true;
  state.get_good_flights.data = action.payload || [];
};
